import { render, staticRenderFns } from "./ContactDocuments.vue?vue&type=template&id=1c05acd5&"
import script from "./ContactDocuments.vue?vue&type=script&lang=js&"
export * from "./ContactDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports